import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { RequestTypes } from '../requestTypes'
import { companyKeys } from '../companyKeys'
import { OrganisationCompany } from '@core/entities/company'

export const useAddCompany = (
  options?: UseMutationOptions<
    OrganisationCompany,
    RequestErrorType,
    RequestTypes['addCompany']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...options,
    ...companyKeys.addCompany,
    onSuccess: (...args) => {
      queryClient.invalidateQueries(companyKeys.getCompanies._def)

      options?.onSuccess?.(...args)
    },
  })
}
